import { API_URL } from "@/_plugins/axios";
import withoutWatchersMixin from "@/_plugins/withoutWatchersMixin";
import debounce from "lodash/debounce";
import Multiselect from "vue-multiselect";
import Form from "@/_plugins/form";
import Pagination from "laravel-vue-pagination";
import HasError from "@/components/HasError";
import i18n from "@/_plugins/i18n";
import DetailsModal from "@/components/DetailsModal";

export default {
  mixins: [withoutWatchersMixin],
  name: "Notification",
  components: {
    // HelloWorld,
    Multiselect,
    Pagination,
    HasError,
    DetailsModal,
  },
  data() {
    return {
      users: [],
      selectedUsers: [],
      sectors: [],
      selectedSectors: [],
      deleteId: null,
      notification: null,
      notifications: {},
      currUsers: [],
      notificationForm: new Form({
        users: [],
        notification: "",
      }),
      value: null,
      currentPage: 1,
      loading: false,
      deleting: false,
      filters: {
        term: "",
      },
    };
  },
  methods: {
    details(i) {
      this.notification = i;
      this.$bvModal.show("details");
    },
    deleteNotification() {
      this.deleting = true;
      API_URL.delete(`notification/${this.deleteId}`).then(() => {
        this.currentPage = 1;
        this.getNotifications();
        this.$toast.success(i18n.tc("notifications.success"));
        this.closeModal();
        this.deleting = false;
      });
    },
    closeModal() {
      this.notificationForm.reset();
      this.selectedSectors = [];
      this.selectedUsers = [];
      this.$bvModal.hide("deleteNotification");
      this.$bvModal.hide("modal-2");
      this.deleteId = null;
      this.item = null;
      this.modalTitle = i18n.tc("equipment.add_new_equipment");
    },
    userDetails(users) {
      this.currUsers = users;
      this.$bvModal.show("users-details");
    },
    submitNotificationForm() {
      this.notificationForm.users = this.selectedUsers;
      this.notificationForm
        .post("send-notification")
        .then(() => {
          this.getNotifications();
          this.$toast.success(i18n.tc("notifications.success"));
          this.closeModal();
        })
        .catch(() => {
          // console.log("ERROR", error.data);
        });
    },
    deleteModal(notification_ids) {
      this.deleteId = notification_ids;
      this.$bvModal.show("deleteNotification");
    },
    getNotifications() {
      this.loading = true;
      API_URL.get("admin-notifications", {
        params: {
          page: this.currentPage,
          is_new: true,
          ...this.filters,
        },
      }).then((response) => {
        this.notifications = response.data;
        this.loading = false;
      });
    },
    getAllSectors() {
      API_URL.get("sector").then((response) => {
        console.log(response.data);
        this.sectors = response.data.data;
        this.sectors.unshift({ id: "all", name: "Izaberi sve" });
      });
    },
    onSelectSector(selected) {
      console.log(selected);
      if (selected.id === "all") {
        this.selectedSectors = this.sectors.filter(
          (sector) => sector.id !== "all"
        );
        this.getAllUsers();
      } else {
        this.selectedSectors.push(selected);
        this.getUsersBySector(this.selectedSectors);
      }
    },
    onRemoveSector(selected) {
      this.selectedUsers = this.selectedUsers.filter(
        (user) => user.sector_id !== selected.id
      );
      this.selectedSectors.splice(this.selectedSectors.indexOf(selected), 1);
      this.getUsersBySector(this.selectedSectors);
    },
    onSelectUser(selected) {
      console.log(selected);
      if (selected.id === "all") {
        this.selectedUsers = this.users.filter((sector) => sector.id !== "all");
      } else {
        this.selectedUsers.push(selected);
      }
    },
    onRemoveUser(selected) {
      this.selectedUsers.splice(this.selectedUsers.indexOf(selected), 1);
    },
    getUsersBySector(sectors) {
      if (sectors.length) {
        API_URL.get("users/all", {
          params: {
            sectors: this.selectedSectors,
          },
        }).then((response) => {
          console.log(response.data);
          this.users = response.data;
          this.users.unshift({ id: "all", full_name: "Izaberi sve" });
        });
      } else this.users = [];
    },
    getAllUsers() {
      API_URL.get("users/all").then((response) => {
        this.users = response.data;
        this.users.unshift({ id: "all", full_name: "Izaberi sve" });
      });
    },
  },
  computed: {
    resultsCount() {
      return this.notifications?.data?.length;
    },
  },
  watch: {
    filters: {
      deep: true,
      immediate: false,
      // eslint-disable-next-line no-unused-vars
      handler: debounce(function (value) {
        this.$withoutWatchers(() => (this.currentPage = 1));
        this.getNotifications();
      }, 250),
    },
    currentPage() {
      this.getNotifications();
    },
  },
  mounted() {
    this.getNotifications();
    this.getAllSectors();
    this.$emit("loadBreadcrumbLink", {
      pageName: "Notifikacije",
    });
  },
};
